import i18n, { use } from "i18next";
import { initReactI18next } from "react-i18next";
import { defaultI18nConfig } from "@ascleo/frontdesk-shared";

if (!i18n.isInitialized) {
  void use.call(i18n, initReactI18next).init(defaultI18nConfig);
}

export { i18n };
